import React from "react";
import SnackbarProvider from "components/Snackbar/SnackbarProvider";
import WarningSnackbar from "components/WarningSnackbar";
import BillingRecoveryBanner from "components/BillingRecoveryBanner";
import ErrorModal from "./ErrorModal";

/**
 * Minimal shell for standalone auth screens that must NOT mount the authenticated
 * app shell (SideMenu / TopBar / DashboardChatbot). Those components fire authed
 * requests on mount; under the REF-5421 `must_set_password` hard gate every such
 * request 403s, producing console/Sentry noise (and a CRA dev error overlay) while
 * a gated guest is on `/set-password`. Rendering the page bare avoids it entirely.
 *
 * Keeps only event-driven, auth-agnostic UI (snackbars, error modal) and the payment-problem banner, which reads the
 * store and requests nothing until a billing manager clicks it (P7 Faz 1). Extra
 * layout props (isSideMenuFixed, hiddenHeader, …) are accepted and ignored.
 */
const MinimalLayout = ({ children }: { children: React.ReactNode; [key: string]: any }) => {
  return (
    <main className="flex flex-col bg-trueWhite" style={{ minHeight: "100%" }}>
      <SnackbarProvider />
      <WarningSnackbar />
      <BillingRecoveryBanner />
      {children}
      <ErrorModal />
    </main>
  );
};

export default MinimalLayout;
